export default __webpack_public_path__ + "static/media/img-06.896c4938.jpg";